// /orgs/$orgSlug/projects/$projectId/settings/task-types (B8).
//
// Route shell. Project access is enforced server-side; the page gates
// editing on org role and the route surfaces 403/404 here.

import { createFileRoute, Link } from '@tanstack/react-router';

import { ApiError, apiErrorMessage } from '../api/client';
import { ProjectTaskTypesPage } from '../components/ProjectTaskTypesPage';

export const Route = createFileRoute(
  '/orgs/$orgSlug/projects/$projectId/settings/task-types'
)({
  component: TaskTypesSettingsRoute,
  errorComponent: TaskTypesSettingsRouteError,
});

function TaskTypesSettingsRoute(): React.JSX.Element {
  const { orgSlug, projectId } = Route.useParams();
  return (
    <ProjectTaskTypesPage orgSlug={orgSlug} projectId={projectId} />
  );
}

function TaskTypesSettingsRouteError({
  error,
}: {
  error: unknown;
}): React.JSX.Element {
  const isApi = error instanceof ApiError;
  const status = isApi ? error.status : null;
  const heading =
    status === 403
      ? 'You don’t have access to this project'
      : status === 404
        ? 'Project not found'
        : 'Something went wrong loading project settings';
  const body = apiErrorMessage(error, 'Try again, or pick a different project from the organization page.');

  return (
    <div className="mx-auto max-w-2xl py-7">
      <p className="text-text-faint text-11 mb-2 uppercase tracking-wider">
        Error
      </p>
      <h1 className="text-text text-28 mb-3 font-semibold">{heading}</h1>
      <p className="text-text-muted mb-5 text-13">{body}</p>
      <Link
        to="/"
        className="bg-accent text-accent-fg border-border-strong rounded-2 hover:bg-accent-hi inline-block border px-3 py-2 text-13 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
